export interface CommonState {
  /** Placeholder for cross-cutting UI flags; keep lean — no page-owned lists. */
  ready: boolean;
}

export const initialCommonState: CommonState = {
  ready: true,
};
